import { useEffect } from 'react';

/**
 * Meta Pixel base code — The Parkour Class-Ready Megapack.
 * Single source of truth for the pixel id: this is the only place it is
 * initialised, and the guards below keep PageView from firing more than once
 * per page load (including React StrictMode double-mounts and re-renders).
 */
const PIXEL_ID = '1454574839977604';
type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push: Fbq;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
    __metaPixelPageViewSent?: Record<string, boolean>;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined' || !PIXEL_ID) return;
    const sent = window.__metaPixelPageViewSent ??= {};
    if (sent[PIXEL_ID]) return;
    sent[PIXEL_ID] = true;
    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) fbq.callMethod(...args);else fbq.queue.push(args);
      } as Fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
  }, []);
  return null;
}